import React, { useState } from 'react';
import { VersionCheckInteractor } from './versionCheck';
import { useVersionCheck } from './useVersionCheck';

interface VersionRefreshBannerProps {
  /** Test seam; defaults to the app-wide singleton. */
  interactor?: VersionCheckInteractor;
  /** Test seam; jsdom forbids stubbing location.reload. */
  reload?: () => void;
}

/**
 * App-level "new deploy shipped" notice. Never reloads on its own — the user
 * may be mid-edit or mid-drag — it only offers a Refresh button. Dismissing
 * suppresses it until the next reload.
 */
export const VersionRefreshBanner: React.FC<VersionRefreshBannerProps> = ({
  interactor,
  reload = () => window.location.reload(),
}) => {
  const isStale = useVersionCheck(interactor);
  const [isDismissed, setIsDismissed] = useState(false);

  if (!isStale || isDismissed) {
    return null;
  }

  return (
    <div className="version-refresh-banner" role="status" aria-live="polite">
      <span>A new version of this app is available.</span>
      <button type="button" className="btn btn-primary btn-small" onClick={reload}>
        Refresh
      </button>
      <button
        type="button"
        className="btn-x"
        aria-label="Dismiss"
        onClick={() => setIsDismissed(true)}
      >
        ✕
      </button>
    </div>
  );
};
